import { useState, useCallback, useMemo } from "react";
import EnumsContext from "./enums-context";

const initialEnumsState = {
  product_groups: createEnumState(),
  statuses: createEnumState(),
  divisions: createEnumState(),
  financial_data_types: createEnumState(),
  cagent_types: createEnumState(),
  partners: createEnumState(),
  pay_statuses: createEnumState(),
  service_groups: createEnumState(),
  clients: createEnumState(),
  users: createEnumState(),
  brands_dictionary: createEnumState()
};

function createEnumState() {
  return {
    loaded: false,
    data: null
  };
}

const EnumsProvider = ({ children }) => {
  const [enums, setEnums] = useState(initialEnumsState);

  const setEnum = useCallback((key, data) => {
    setEnums(prev => ({
      ...prev,
      [key]: {
        loaded: true,
        data
      }
    }));
  }, []);

  const resetEnum = useCallback((key) => {
    setEnums(prev => ({
      ...prev,
      [key]: createEnumState()
    }));
  }, []);

  const value = useMemo(() => ({
    enums,
    setEnum,
    resetEnum
  }), [enums, setEnum, resetEnum]);

  return (
    <EnumsContext.Provider value={value}>
      {children}
    </EnumsContext.Provider>
  );
};

export default EnumsProvider;